export const adviceTeacher = [
   {
     boldTitle: "Індивідуальний підхід:",
     text: "Враховуйте індивідуальні потреби та рівень кожного студента. Регулярно проводьте оцінку їхнього прогресу та надавайте персоналізовані рекомендації.",
   },
   {
     boldTitle: "Зворотній зв'язок:",
     text: "Регулярно надавайте студентам конструктивний зворотній зв'язок. Вказуйте на їхні успіхи та області, де вони можуть покращити свої навички.",
   },
   {
     boldTitle: "Мотивація та підтримка:",
     text: "Заохочуйте студентів досягати своїх цілей та підтримуйте їх на кожному етапі навчання. Позитивна атмосфера сприяє кращому засвоєнню матеріалу.",
   },
   {
     boldTitle: "Постійне вдосконалення:",
     text: "Слідкуйте за новими методиками та підходами у викладанні мови. Підвищуйте свою кваліфікацію через тренінги, курси та участь у професійних спільнотах.",
   },
];

export const rulesTeacher = [
    {
      boldTitle: "Вимоги",
      text: "",
    },
    {
      boldTitle: "",
      text: "Уроки повинні тривати: Пробний урок - 30хв, Діти - 45хв, Підлітки - 50хв, Дорослі - 50хв.",
    },
    {
      boldTitle: "",
      text: "Уроки проводяться з увімкненою камерою, гарнітурою для кращої якості звуку",
    },
    {
      boldTitle: "",
      text: "Якщо учень не з'явився на урок протягом перших 5 хвилин, вчитель  повинен написати своєму менеджеру та не виходити з уроку дочекавшись відповіді менеджера",
    },
    {
      boldTitle: "",
      text: "Якщо учень не з'явився на пробному уроці, вчитель має повідомити про це менеджеру та може виходити через 15хв від початку уроку.",
    },
    {
      boldTitle: "Система штрафів",
      text: "",
    },
    {
      boldTitle: "",
      text: "Неявка на урок без попередження — штраф 150 грн або попередження; Компанія повинна надати учню безкоштовний урок.",
    },
    {
      boldTitle: "",
      text: "Відміна уроку у день його проведення (після 21:00 попереднього дня) — штраф 75 грн або попередження.",
    },
    {
      boldTitle: "",
      text: "Неповідомлення менеджера про відсутність учня на занятті — урок не оплачується.",
    },
    {
      boldTitle: "",
      text: "Неповідомлення менеджера про технічні проблеми через які не відбувся урок — урок не оплачується.",
    },
    {
      boldTitle: "",
      text: "Ігнорування повідомлень від менеджера в Telegram понад 2 дні — штраф 125 грн або попередження. У разі систематичного ігнорування Компанія має право розірвати Договір.",
    },
    
    {
    boldTitle: "З повним договором ви можете ознайомитись нижче, натиснувши на ДОГОВІР-ОФЕРТА.",
    text: "",
  }
]

export const newFeatureTitleTeacher = "✏️ Новинка: словник учнів"

export const newFeatureTeacher = [
  {
    number: '',
    text: 'Тепер кожен учень має власний словник прямо на платформі.'
  },
  {
    number: '',
    text: 'Ви можете допомогти учню краще запамʼятати слова — додавайте нові слова у його словник після заняття або під час підготовки.'
  },
  {
    number: '',
    text: 'Щоб додати слово, просто оберіть учня зверху, введіть слово та переклад і натисніть "Додати".'
  },
  {
    number: '',
    text: 'Також можна змінювати статус слова: "Нове" або "Вивчено", або видалити, якщо вже не актуальне.'
  },
  {
    number: '',
    text: 'Учень бачить усі додані вами слова у своєму словнику та може їх повторювати.'
  }
]


export const perfectTeacher = [
  {
    title: "Trial / Regular lesson", 
    link: "https://www.canva.com/design/DAGPcgkxRbk/wHC-hDt1is8ljFvVvzE99g/view?utm_content=DAGPcgkxRbk&utm_campaign=designshare&utm_medium=link&utm_source=editor"
  }
]